<template>
  <div class="login-content-box">
    
    <div class="login-right">
      <div class="row">
        <div class="lright-cont">
          <div class="login-content">
            <div class="login">
              <a-form :form="form" @submit="handleSubmitSignIn">
                <div class="drop-down d-quhao">
                  <img
                    src="../../../../assets/img/code/mailbox_login.png"
                    alt=""
                  />
                </div>
                <!-- 请输入邮箱 -->
                <a-form-item>
                  <a-input
                    ref="userEmailInput"
                    allow-clear
                    type="email"
                    :placeholder="getString(strings.Contact_Us_Email)"
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            type: 'email',
                            required: true,
                            message: getString(strings.Input_Email_isNull),
                          },
                        ],
                      },
                    ]"
                  >
                  </a-input>
                </a-form-item>
                <div class="drop-down">
                  <img src="../../../../assets/img/code/verification_code_logo.png" alt="" />
                </div>
                <!-- 请输入邮箱验证码 -->
                <a-form-item class="drcode">
                  <div class="dr-agroup">
                    <a-input
                      allow-clear
                      oninput="if(value.length>6)value=value.slice(0,6);value=value.replace(/[^\d]/g,'')"
                      :placeholder="getString(strings.User_Lolgin_Please_Enter_Verification_Code)"
                      @blur="captchaBlurForValidate"
                      ref="CodeValue"
                      v-decorator="[
                        'captcha',
                        {
                          rules: [
                            {
                              required: true,
                              message: getString(strings.Input_Please_Enter_Verification_Code),
                            },
                            {
                              validator: validataToCode,
                            },
                          ],
                        },
                      ]"
                    >
                    </a-input>
                    <div @click="handleSubmitCode">
                      <a-button
                        class="dra-btn scode"
                        disabled
                        v-if="showTimeData"
                      >
                        {{ timeData }}
                        <span>s</span>
                      </a-button>
                      <a-button class="dra-btn" v-else>{{getString(strings.User_Lolgin_Obtain)}}</a-button>
                    </div>
                  </div>
                </a-form-item>
                <div class="drop-down">
                  <img
                    src="../../../../assets/img/code/pwd_input_logo.png"
                    alt=""
                  />
                </div>
                <!-- 请输入新密码 -->
                <a-form-item has-feedback>
                  <a-input
                    allow-clear
                    oninput="if(value.length>24)value=value.slice(0,24)"
                    :placeholder="getString(strings.User_Lolgin_Please_Enter_New_Password)"
                    ref="newPassword"
                    @blur="newPasswordBlurForValidate"
                    v-decorator="[
                      'newPassword',
                      {
                        rules: [
                          {
                            required: true,
                            message: getString(strings.Input_Please_Enter_A_New_Password),
                          },
                          {
                            validator: validateToNextPassword,
                          },
                        ],
                      },
                    ]"
                    type="password"
                  >
                  </a-input>
                </a-form-item>
                <div class="drop-down">
                  <img
                    src="../../../../assets/img/code/pwd_input_logo.png"
                    alt=""
                  />
                </div>
                <!-- 确认密码 -->
                <a-form-item has-feedback>
                  <a-input
                    allow-clear
                    oninput="if(value.length>24)value=value.slice(0,24)"
                    :placeholder="getString(strings.User_Lolgin_Confirm_Password)"
                    ref="confirm"
                    @blur="confirmBlurForValidate"
                    v-decorator="[
                      'confirm',
                      {
                        rules: [
                          {
                            required: true,
                            message: getString(strings.Input_Confirm_The_New_Password),
                          },
                          {
                            validator: compareToFirstPassword,
                          },
                        ],
                      },
                    ]"
                    type="password"
                  >
                  </a-input>
                </a-form-item>

                <a-form-item v-bind="tailFormItemLayout">
                  <a-button
                    class="Login-Button"
                    type="primary"
                    html-type="submit"
                  >
                    {{getString(strings.User_Lolgin_Reset)}}
                  </a-button>
                </a-form-item>
                <span class="lc-zi">
                  <label>{{getString(strings.User_Lolgin_Already_Have_An_Account)}}</label>
                  <a href="javascript:;" @click="clickLoginShow()" class="sign-a">
                    {{getString(strings.User_Lolgin_To_Log_In)}}
                  </a>
                </span>
              </a-form>
            </div>
          </div>
          <div class="Login-code" @click="ClickShowCode">
            <img src="../../../../assets/img/code/qrcode9.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import {
  postUserEmailCaptcha,
  postUserEmailResetPassword,
} from "../../../../common/netWork/base_api";
import strings from "../../../../common/lang/strings";
import getString from "../../../../common/lang/language";
import sign from "../../../../assets/css/login/sign.less";

export default {
  name: "Login",
  data() {
    return {
      confirmDirty: false,
      // autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
      SignInData: {
        areaCode: "",
        phoneNumber: "",
      },
      timeData: "",
      showTimeData: false,
      phoneNumberValidateCallback: null,
      captchaValidateCallback: null,
      newPasswordValidateCallback: null,
      confirmValidateCallback: null,
      ShowCode: true,
      strings: strings,
    };
  },
  components: {
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "register" });
  },
  created() {},
  mounted() {
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    getString(i) {
      return getString(i);
    },
    // 获取验证码
    handleSubmitCode(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(
        ["email"],
        {
          first: true,
        },
        (err, values) => {
          // console.log('走入了获取验证码',values)
          if (!err) {
            postUserEmailCaptcha(
              values,
              (res) => {
                if (res == false) {
                  this.showTimeData = res;
                } else {
                  this.showTimeData = true;
                  // this.timeData = res;
                  //这里应该是验证码再次获取的秒数。
                  this.timeData = 60;
                  let countDown = setInterval(() => {
                    if (this.timeData < 1) {
                      this.timeData = 0;
                      this.showTimeData = false;
                      clearInterval(countDown);
                    } else {
                      this.timeData--;
                    }
                  }, 1000);
                }
              },
              (error) => {
                this.$message.error(error.desc);
              }
            );
          }
        }
      );
    },
    // 忘记密码重置
    handleSubmitSignIn(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(
        ["email", "newPassword", "captcha", "confirm"],
        { first: true },
        (err, values) => {
          // console.log('values',values)
          if (!err) {
            values.password = values.newPassword;
            postUserEmailResetPassword(
              values,
              (res) => {
                this.$message.success(getString(strings.Message_Tips_Modification_Success));
                this.clickLoginShow();
               },
              (error) => {
                this.$message.error(error.desc);
              }
            );
          }
        }
      );
    },
    // 失去焦点
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    // 登录注册切换
    clickLoginShow(ShowLogin) {
      this.$emit("ClickLoginShow", "MailboxLogin");
    },

    // 确认密码验证
    compareToFirstPassword(rule, value, callback) {
      this.confirmValidateCallback = callback;
      // const form = this.form;
      if (this.confirm != "") {
        if (!(value != this.$refs.newPassword.value)) {
          callback();
        }
      } else {
        callback();
      }
    },
    confirmBlurForValidate(e) {
      if (this.confirmValidateCallback == null) {
        return;
      }
      let value = this.$refs.confirm.value;
      if (value != this.$refs.newPassword.value) {
        this.confirmValidateCallback(getString(strings.Input_The_Passwords_Are_Inconsistent));
      } else {
        this.confirmValidateCallback();
      }
      return;
    },

    // 密码验证
    validateToNextPassword(rule, value, callback) {
      this.newPasswordValidateCallback = callback;
      // const form = this.form;
      if (this.newPassword != "") {
        const PassWordValue = /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*])|(?=.*\d)(?=.*[#@!~%^&*]))[a-z\d#@!~%^&*]{8,24}/i;
        if (!(!PassWordValue.test(value) && value)) {
          callback();
        }
      } else {
        callback();
      }
    },
    newPasswordBlurForValidate(e) {
      if (this.newPasswordValidateCallback == null) {
        return;
      }
      let value = this.$refs.newPassword.value;
      // console.log("密码", value);
      if (this.newPassword != "") {
        const PassWordValue = /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*])|(?=.*\d)(?=.*[#@!~%^&*]))[a-z\d#@!~%^&*]{8,24}/i;
        if (!PassWordValue.test(value) && value) {
          this.newPasswordValidateCallback(getString(strings.Input_The_Password_Format_Is_Incorrect));
        } else {
          this.newPasswordValidateCallback();
        }
      } else {
        this.newPasswordValidateCallback(getString(strings.Input_Please_Enter_The_Password));
      }
    },

    // 手机号验证
    phoneNumber(rule, value, callback) {
      this.phoneNumberValidateCallback = callback;
      if ("" + this.countryCode == "86") {
        var iphoneNumber = /^[1][[0-9][0-9]{9}$/;
        if (!(!iphoneNumber.test(value) && value)) {
          callback();
        }
      } else {
        if ((value + "").length > 4 && (value + "").length < 20) {
          callback();
        }
      }
    },
    //手机号验证焦点离开判断
    phoneNumberBlurForValidate(e) {
      if (this.phoneNumberValidateCallback == null) {
        return;
      }
      let value = this.$refs.phoneNumber.value;
      if ("" + this.countryCode == "86") {
        var iphoneNumber = /^[1][[0-9][0-9]{9}$/;
        if (!iphoneNumber.test(value) && value) {
          this.phoneNumberValidateCallback(getString(strings.Input_Please_Enter_A_Valid_Phone_Number));
        } else {
          this.phoneNumberValidateCallback();
        }
      } else {
        if ((value + "").length <= 4 || (value + "").length >= 20) {
          this.phoneNumberValidateCallback(getString(strings.Input_Please_Enter_A_Valid_Phone_Number));
        } else {
          this.phoneNumberValidateCallback();
        }
      }
    },
    // 验证码验证
    validataToCode(rule, value, callback) {
      this.captchaValidateCallback = callback;
      if ((value + "").length > 1 || (value + "").length < 6) {
        callback();
      } else {
        const iCaptcha = /^[0-9]*$/;
        if (!(!iCaptcha.test(value) && value)) {
          callback();
        }
      }
    },
    captchaBlurForValidate(e) {
      if (this.captchaValidateCallback == null) {
        return;
      }
      let value = this.$refs.CodeValue.value;
      if ((value + "").length <= 1 || (value + "").length >= 6) {
        this.captchaValidateCallback(getString(strings.Input_The_Please_Enter_The_Correct_Verification_Code));
      } else {
        const iCaptcha = /^[0-9]*$/;
        if (!iCaptcha.test(value) && value) {
          this.captchaValidateCallback(getString(strings.Input_The_Verification_Code_Error));
        } else {
          this.captchaValidateCallback();
        }
      }
    },
    // 二维码界面
    ClickShowCode() {
      this.$emit("ClickShowCode", !this.ShowCode);
    },
  },
  destroy() {
    clearInterval();
  },
};
</script>

<style scoped>
.Login-content {
  /* background-image: url(../../assets/img/page/reg_bg_min.jpg); */
  background-size: cover;
  /* width: 1900px; */
  min-height: 1920px;
  min-height: 99vh;
}
.hello {
  width: 600px;
  min-width: 800px;
  min-height: 99.9vh;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-content-box {
  position: relative;
  border-radius: 0px 8px 8px 0px;
  display: flex;
  justify-content: center;
  height: 505px;
  margin: 0 auto;
  width: inherit;
  position: relative;
  background-color: #ffffff;
}
 
.login-right {
  margin-top: 80px;
}
.login-right .row {
  width: 363px;
  /* border: 1px red solid; */
}
.login-right .lright-cont {
  width: 94%;
  margin-left: 1em;
  min-width: auto;
  /* border: 1px rgb(0, 140, 255) solid; */
}
.Login-container {
  padding: 20px 0px;
}

.login-right .lc-titel {
  display: flex;
}
.lc-titel h2 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  /*font-weight: bold;*/
  line-height: 31px;
  color: #404040;
  opacity: 1;
}

/*QR code*/
.Code-titel {
  width: 100%;
  text-align: center;
}
.Login-code {
  width: 60px;
  height: 60px;
  position: absolute;
  right: 0px;
  bottom: 0px;
  cursor: pointer;
}
.Code-bottom-text {
  text-align: center;
}
.Code-bottom-text p {
  margin-top: 5px;
}
.Login-code img {
  width: 100%;
}
.Code-content img {
  width: 100px;
  height: 100px;
}
.Code-box {
  width: 100px;
  margin: 0 auto;
}
.login-content {
  margin: auto;
}
.login-content .ai-group {
  width: 334px;
  height: 56px;
  padding-left: 20%;
  border-radius: 4px;
}
.login-content .pcode {
  padding-left: 13% !important;
}
.login {
  height: 100%;
  position: relative;
  margin-top: 10px;
}

/*ant design style*/
/* .ant-form {
  width: 400px;
} */
.Login-Button {
  width: 334px;
  height: 44px;
}
.checked-box {
  position: relative;
  top: -30px !important;
}
#register_agreement {
  border-color: red;
}
/* .ant-btn-primary:hover{
  background-color: #ad0917 !important;
  border-color: #ad0917 !important;
} */
/* .ant-btn:hover{
  background-color: #fb3848;
  color: #ffffff;
  border: 1px solid #fb3848;
} */
/* 更改 */
.ant-btn-primary {
  margin-left: -50% !important;
  background-color: #fd492b !important;
  border-color: #fd492b !important;
  border-radius: 26px;
  font-size: 18px;
}

.ant-btn-primary:hover {
  background-color: #ff7354 !important;
  border-color: #ff7354 !important;
}
.password-a {
  color: #fd492b;
  float: right;
}
.lc-zi {
  float: right;
  position: relative;
  bottom: 32px;
  right: 32px;
}
.sign-a {
  color: #fd492b;

  line-height: 45px;
}
.sign-a:hover {
  color: #ff7354;
}
.ho-a:hover {
  color: #ff7354;
}
.password-label {
  color: #fd492b;
  float: left;
}
.dr-agroup {
  display: flex;
  width: 334px;
}
.dr-agroup .dra-btn {
  float: right;
  width: 59px;
  height: 44px;
  background: #fd492b;
  border: none;
  font-size: 16px;
  color: #fff;
  opacity: 1;
  border-radius: 4px;
  margin-left: 10px;
  padding: unset;
}
.dr-agroup .dra-btn:hover {
  background-color: #ff7354 !important;
  border-color: #ff7354 !important;
}
.dr-agroup .scode {
  color: #999999;
  background-color: #e8e8e8 !important;
}
.dr-agroup .scode:hover {
  background-color: #e8e8e8 !important;
  border-color: #e8e8e8 !important;
}
/*模态框 */
.drop-down {
  position: absolute;
  z-index: 5;
  margin-top: 10px;
  margin-left: 15px;
  /* margin: 0px 15px; */
  align-items: center;
}
.d-quhao {
  margin-top: 14.5px;
  display: flex;
}
.flag-list-box {
  background-color: #fff !important;
  width: 304px !important;
}
.login-content .phonr {
  padding-left: 56%;
}
.ant-select-selection {
  border: none;
  background: none;
}
.login-content .dr-deon {
  margin: 8px;
  font-size: 14px;
  font-family: Noto Sans SC;
  font-weight: 400;
  line-height: 20px;
  color: #333333;
}
.login-content .lbtwo {
  margin-bottom: unset;
  padding-top: 20px;
}
</style>
<style>
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: red;
  border: none;
  color: rgba(0, 0, 0, 0.8);
}
.ant-form-item {
  margin-bottom: 24px;
}
.login-content .ai-group:hover {
  border: 1px #555 solid;
}
.ant-input:focus {
  border: 1px #555 solid;
  box-shadow: unset;
}
/* .flag-list-box {
  background-color: #fff !important;
  width: 304px !important;
} */
</style>

<style lang="less" scoped>
@media screen and(min-width:250px) and(max-width:600px) {
  /* 更改 */
  .ant-btn-primary {
    margin-left: 0% !important;
    background-color: #fd492b !important;
    border-color: #fd492b !important;
    border-radius: 26px;
    font-size: 18px;
    /* margin-left: -7.5em; */
  }
}
@media screen and(min-width:250px) and(max-width:500px) {
  .flag-list-box {
    background-color: #fff !important;
    width: 261px !important;
  }
  .login-content-box {
    height: 100%;
  }
  .Login-header {
    width: 100%;
    position: static;
  }
  .hello {
    width: 100%;
    min-width: 0;
    .login-right {
      padding: 0;
      margin-top: 0;
      margin: 0 auto;
      width: 100%;
      .row {
        width: 100%;
      }
      .lright-cont {
        margin: 10px;
      }
    }
  }
  .Login-code {
    width: 30px;
    height: 30px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .get-back {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    font-size: 16px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
   
  .login-content {
    padding-top: 0;
    .login {
      margin-top: 15px;
      .ant-form {
        width: 100%;
        .ant-form-item {
          .ant-col {
            .ant-form-item-control {
              .ant-form-item-children {
                .dr-agroup {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
    .lbtwo {
      padding-top: 0px;
      height: 23px;
    }
  }
  .Login-Button {
    height: 48px;
    margin-top: 11px;
    width: 100%;
  }
  .lc-titel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    h2 {
      line-height: 42px;
      font-size: 18px;
    }
    .lc-titel-a {
      width: auto !important;
    }
  }
}
</style>
